var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar',{staticStyle:{"z-index":"99"}}),_c('div',{staticClass:"text-center"},[(_vm.$store.state.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1),_c('v-main',[_c('SnackBar'),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }